/** Matches AppUpdateAvailability.UPDATE_AVAILABLE from @capawesome/capacitor-app-update */
const STORE_UPDATE_AVAILABLE = 2

export function nativeStoreUpdateFromInfo(info: {
  updateAvailability: number
  availableVersionName?: string
  availableVersionCode?: string
}): { key: string; versionLabel: string | null } | null {
  if (info.updateAvailability !== STORE_UPDATE_AVAILABLE) {
    return null
  }

  const versionLabel = info.availableVersionName?.trim() || null
  return {
    key: versionLabel ?? info.availableVersionCode ?? "available",
    versionLabel
  }
}

export function isNativeStoreUpdateSkippable(
  firstCheckCompleted: boolean,
  startupUpdateOutstanding: boolean
): boolean {
  return firstCheckCompleted && !startupUpdateOutstanding
}
